import PropTypes from 'prop-types';
import React from 'react';

const TextWithHighlight = props => (
    <div className="stimulus-text">
        {props.textDataArr.map(item => {
            if (item === props.highlightedTemplate) {
                return (
                    <span key={item}>
                        <u aria-label={item} aria-live="polite">
                            {item}
                        </u>
                    </span>
                );
            }
            return (
                <span key={item} aria-label={item} aria-live="polite">
                    {item}
                </span>
            );
        })}
    </div>
);

TextWithHighlight.propTypes = {
    textDataArr: PropTypes.array,
    highlightedTemplate: PropTypes.string,
};

TextWithHighlight.defaultProps = {
    textDataArr: [],
    highlightedTemplate: '',
};

export default TextWithHighlight;
